// questa funzione ritorna false (= errore) se il profile ha almeno uno dei campi requiredKeys non valorizzato
// viene creato un oggetto errors che è un collezione di key-value pair con:
// key: un campo del profile che appare tra le requiredKeys
// value: se true significa che la rispettiva chiave non è valorizzata su profile
export function validateProfile(profile, setErrorKeys) {
    const errors = {};
    // prettier-ignore
    const requiredKeys = [
        //'neutralPalette', 
        //'primaryPalette', 
        'name',
        // 'language', 
        'themeId'
    ];
    requiredKeys.forEach((key) => {
        if (!isValid(profile, key, 'required')) errors[key] = true;
    });
    setErrorKeys(errors);
    return Object.values(errors).length === 0;
}

export function validateUser(user, users, setErrorObj) {
    const errors = {};
    // prettier-ignore
    const requiredKeys = [
        'email',
        'firstName',
        'lastName'
    ];

    const emailKeys = ['email'];

    const phoneNumberKeys = ['phoneNumber'];

    requiredKeys.forEach((key) => {
        if (!isValid(user, key, 'required')) errors[key] = { text: _t.validation.fieldRequired(key), value: true }; // TODO: add text
    });

    phoneNumberKeys.forEach((key) => {
        if (!isValid(user, key, 'phoneNumber'))
            errors[key] = { text: _t.global.validation.invalidPhoneNumber(), value: true }; // TODO: add text
    });

    emailKeys.forEach((key) => {
        if (!isValid(user, key, 'email')) errors[key] = { text: _t.global.validation.invalidEmail(), value: true };
    });

    setErrorObj(errors);
    return Object.values(errors).length === 0;
}

const isEmpty = (value) => value === undefined || value === null || value === '';

// returns:
// - true if there is no error against the conditioh
// - false otherwise
export function isValid(entity, key, condition) {
    const value = key === 'themeId' ? entity.styles[key] : entity[key];
    switch (condition) {
        case 'required':
            return value !== null && value !== undefined && value !== '';
        case 'email':
            return email(entity[key]);
        case 'phoneNumber':
            return phoneNumber(entity[key]);
        case 'password':
            return password(entity[key]);
        default:
            return entity[key];
    }
}

function email(value) {
    // email con @ e .
    return isEmpty(value) || /^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,}$/.test(value);
}

function phoneNumber(value) {
    // prefisso required e min 7 cifre
    return isEmpty(value) || /^\+\d{1,3}\d{7,12}$/.test(value);
}

function password(password) {
    const regex = /^(?=.*[A-Z])(?=.*[a-z])(?=.*[0-9])(?=.*[\^$*.[\]{}()?"!@#%&/\\,><':;|_~`=+\- ])[A-Za-z0-9^$*.[\]{}()?"!@#%&/\\,><':;|_~`=+\- ]{10,256}$/;
    return regex.test(password);
}
